<ng-container>
    <div class="modal-header">
        <h4 class="modal-title pull-left header-style">
            {{title}}
        </h4>
    </div>
    <div class="modal-body">
        <form [formGroup]="jobForm" class="form-color">
            <label class="required_field label-position">{{labelType}}</label>
            <select csSelect2 class="select-to-width date-height" formControlName="reason" [select2Config]="select2Config">
                <option value="" disabled selected translate>Please.Choose</option>
                <option *ngFor="let reason of reasons" [value]="reason.id">{{ reason.description }}</option>
            </select>
        </form>

    </div>

    <!--panel footer-->
    <div class="modal-footer button-alignment">
        <div>
            <button class="btn btn-primary primary-button" [disabled]="jobForm.invalid" (click)="onSubmit()" translate>Save</button>
        </div>
        <div>
            <a href="javascript:void(0)" class="btn" (click)="sidePanelModalRef.hide()">Cancel</a>
        </div>
    </div>
</ng-container>
